import { Injectable } from '@angular/core';
//import {Http, Response} from '@angular/http';

import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AllMastersService {
	getDetails(school_id: any) {
		throw new Error('Method not implemented.');
	}
	getMasters(data: { collection_name: string }) {
		throw new Error('Method not implemented.');
	}
	constructor(private httpClient: HttpClient) {}
	// constructor(//private http: Http) {
	//http.get('api/departments')
	// .map((res: Response) => res.json())
	//.subscribe((departments: Array<any>) => this.departments = departments);
	// }
	fetchMasterParameters(masterTableName) {
		// console.log(masterTableName);
		return this.httpClient.get(environment.apiUrl + '/fetchMasterParameters?master_table_name=' + masterTableName);
	}
	fetchMasterRecords(masterTableName) {
		return this.httpClient.get(environment.apiUrl + '/fetchMasterRecords?master_table_name=' + masterTableName);
	}
	fetchDevicesDetails() {
		return this.httpClient.get(environment.apiUrl + '/fetchAllDevicesDetails');
	}
	addMasterRecord(master1) {
		return this.httpClient.post(environment.apiUrl + '/addMasterRecord', master1);
	}
	updateMasterRecord(master2) {
		return this.httpClient.post(environment.apiUrl + '/updateMasterRecord', master2);
	}
	organizationDetails(id) {
		return this.httpClient.get(environment.apiUrl + '/organizationDetails?id=' + id);
	}
	fetchSchoolDetails(school_id) {
		return this.httpClient.get(environment.apiUrl + '/fetchSchoolDetails?school_id=' + school_id);
	}

	fetchRecordsFromMasters(master_table_name) {
		return this.httpClient.get(
			environment.apiUrl + '/fetchRecordsFromMasters?master_table_name=' + master_table_name
		);
	}

	updateTimetableSlotsMaster(details) {
		return this.httpClient.post(environment.apiUrl + '/updateTimetableSlotsMaster', details);
	}
	deleteMastersRecord(details) {
		return this.httpClient.post(environment.apiUrl + '/deleteMastersRecord', details);
	}
	// //   api path: /fetchMasterParameters
	// //   parameters:-
	// //   {
	// //       "master_table_name":"academic_year_master"
	// //   }
	// //  }

	//  fetchMasterRecords() {
	//   api path: /fetchMasterRecords
	// parameters:-
	// {
	//     "master_table_name":"academic_year_master"
	// }
	// }
	// addMasterRecord(){
	// api path: /addMasterRecord
	// parameters:-
	// {
	//     "master_table_name":"academic_year_master",
	//     "academic_year":"2019-2020",
	//     "academic_year_description":"For acadamic year of 2019-2020"
	// }
	// }
	// updateMasterRecord(){
	// api path: /updateMasterRecord
	// parameters:-
	// {
	//     "id":"2",
	//     "master_table_name":"academic_year_master",
	//     "academic_year":"2019-2020",
	//     "academic_year_description":"For acadamic year of 2019-2020"
	// }
	// }

	fetchCurrentAndFuturedAY() {
		return this.httpClient.get(environment.apiUrl + '/fetchCurrentAndFuturedAY');
	}
	fetchAllClassType() {
		return this.httpClient.get(environment.apiUrl + '/fetchAllClassType');
	}
	fetchAllVendorCategory()
	{
		return this.httpClient.get(environment.apiUrl + '/fetchAllVendorCategory');
	}
	fetchAllVendorQualityRatings()
	{
		return this.httpClient.get(environment.apiUrl + '/fetchAllVendorQualityRatings');
	}
	fetchDocumentTypesBasedOnUserType(userType) {
		return this.httpClient.post(environment.apiUrl + '/fetchDocumentTypesBasedOnUserType', userType);
	}
	uploadLogo(document_details) {
		return this.httpClient.post(environment.apiUrl + '/uploadLogo', document_details);
	  }
  downloadLogo(path) {
    return this.httpClient.get(environment.apiUrl + '/downloadLogo?path=' + path, {
      responseType: 'blob'
    });
  }
  fetchOrganizationalDependentRecord(details) {
		return this.httpClient.post(environment.apiUrl + '/fetchOrganizationalDependentRecord', details);
	}
}
